var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_53127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 21.2251L10.7751 16L16.0003 10.7749V0L1.07762 14.9227C0.79195 15.2084 0.63147 15.5959 0.63147 16C0.63147 16.4041 0.79195 16.7916 1.07762 17.0773L16.0003 32C16.0003 32 18.286 30.4762 18.286 26.6667C18.1678 24.645 17.3612 22.7248 16.0003 21.2251Z",
    fill: "#2684FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5911 14.9844L11.691 15.0842L16.0003 10.7749V0L7.92334 8.07619C8.53065 10.6564 9.79405 13.0359 11.5911 14.9844Z",
    fill: "#1D78F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6936 13.9314L12.7698 14.0076L16.0018 10.7756V0L9.24524 6.75505C9.6689 9.4327 10.8677 11.9276 12.6936 13.9314Z",
    fill: "#126AE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 10.7749V0L10.667 5.33333C10.7838 8.16397 11.9112 10.859 13.8449 12.9295L16.0003 10.7749Z",
    fill: "#0B60DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1908 5.33333C12.1908 8.94933 14.7866 11.7112 14.9222 11.8522L16.0003 10.7749V0L12.3264 3.6739C12.2353 4.22233 12.1899 4.77739 12.1908 5.33333Z",
    fill: "#0154CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 10.7749L21.2247 16L16.0003 21.2251V32L30.9222 17.0773C31.2079 16.7916 31.3684 16.4041 31.3684 16C31.3684 15.5959 31.2079 15.2084 30.9222 14.9227L16.0003 0C16.0003 0 13.7146 1.52381 13.7146 5.33333C13.8328 7.35495 14.6394 9.27521 16.0003 10.7749Z",
    fill: "#2482FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4087 17.0156L20.3089 16.9158L16.0004 21.2252L16.0004 32L24.0766 23.9238C23.4692 21.3437 22.2058 18.9641 20.4087 17.0156Z",
    fill: "#1D78F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3062 18.0686L19.23 17.9924L15.9988 21.2244L15.9988 32L22.7538 25.2449C22.3301 22.5675 21.1316 20.0727 19.3062 18.0686Z",
    fill: "#126AE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 21.2252V32L21.3337 26.6667C21.2168 23.8359 20.089 21.1409 18.155 19.0705L16.0004 21.2252Z",
    fill: "#0B60DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8099 26.6667C19.8099 23.0507 17.2141 20.2888 17.0777 20.1478L16.0004 21.2252V32L19.6743 28.3261C19.765 27.7776 19.8104 27.2226 19.8099 26.6667Z",
    fill: "#0154CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 21.2251L10.7752 16L2.28601 16L2.28601 18.2857L16.0003 32C16.0003 32 18.286 30.4762 18.286 26.6667C18.1678 24.645 17.3612 22.7248 16.0003 21.2251Z",
    fill: "#2684FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_53127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/jira.78cd2102d554092657703b4e36c78f9e.svg";
export { ForwardRef as ReactComponent };